<template>
  <div>
    <v-container
      v-if="report"
      fluid
      :grid-list-xl="$vuetify.breakpoint.mdAndUp"
      :grid-list-md="$vuetify.breakpoint.smAndDown"
    >
      <v-layout row wrap>
        <v-flex xs12 sm8 offset-sm2 md6 offset-md3 v-if="report.isFull">
          <v-alert
            :value="true"
            color="info"
            icon="info"
            outline
          >
            Le rapport "{{ report.title }}" ne peut être modifié car il s'agit d'un rapport complet. Veuillez contacter votre gestionnaire de projet Target First.
          </v-alert>
        </v-flex>
        <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
          <v-card>
            <v-list two-line dense>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ report.title }}</v-list-tile-title>
                  <v-list-tile-sub-title>Titre du rappport (en gris sur la première page)</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon @click="openDialogTitle()" v-if="!report.isFull">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-dialog v-model="dialogTitle" max-width="350" persistent>
                    <v-card>
                    <v-card-title class="primary white--text">
                      {{ $t('edit') | cap }}
                      {{ $t('title') }}
                    </v-card-title>
                    <v-card-text>
                      <v-text-field
                        v-model.trim="titleTmp"
                        box
                        :label="$t('title') | cap"
                        autofocus
                      ></v-text-field>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat @click="cancelDialogTitle()">{{ $t('cancel') }}</v-btn>
                      <v-btn color="primary" @click="submitDialogTitle()">{{ $t('submit') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                  </v-dialog>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ report.entreprise.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>Entreprise</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ report.lang }}</v-list-tile-title>
                  <v-list-tile-sub-title>Langue du rapport</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon @click="openDialogLang()" v-if="!report.isFull">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-dialog v-model="dialogLang" max-width="350" persistent>
                    <v-card>
                    <v-card-title class="primary white--text">
                      {{ $t('edit') | cap }}
                      {{ $t('language') }}
                    </v-card-title>
                    <v-card-text>
                      <v-select
                        v-model="langTmp"
                        :items="langs"
                        box
                        :label="$t('language') | cap"
                        autofocus
                      ></v-select>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat @click="cancelDialogLang()">{{ $t('cancel') }}</v-btn>
                      <v-btn color="primary" @click="submitDialogLang()">{{ $t('submit') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                  </v-dialog>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ report.createdAt.date | dateTime }}</v-list-tile-title>
                  <v-list-tile-sub-title>Date de création</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ report.updatedAt && report.updatedAt.date | dateTime }}</v-list-tile-title>
                  <v-list-tile-sub-title>Date de modification</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
          <v-card>
            <v-list dense subheader>
              <v-subheader>{{ $tc('emails', 2, {count: ''}) | cap }}</v-subheader>
              <v-list-tile
                v-for="(email, i) in report.emails"
                :key="i"
                v-show="email.indexOf('@targetfirst.com') === -1"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ email }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-menu bottom left v-if="!report.isFull">
                    <v-btn slot="activator" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile @click="openDialogEmail(i, email)">
                        <v-list-tile-title>{{ $t('edit') | cap }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="confirmDeleteEmail(i)">
                        <v-list-tile-title>{{ $t('delete') | cap }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile v-if="!report.isFull">
                <v-btn
                  small
                  flat
                  color="primary"
                  @click="openDialogEmail(-1, '')"
                >{{ $t('add') }} {{ $tc('emails', 1, {count: ''}) }}</v-btn>
                <v-dialog v-model="dialogEmail" max-width="350" persistent>
                  <v-card>
                    <v-card-title class="primary white--text">
                      {{ dialogEmailIndex !== -1 ? $t('edit') : $t('add') | cap }}
                      {{ $t('email') }}
                    </v-card-title>
                    <v-card-text>
                      <v-combobox
                        v-model.trim="emailTmp"
                        :items="emails"
                        box
                        label="Email"
                        autofocus
                      ></v-combobox>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat @click="cancelDialogEmail()">{{ $t('cancel') }}</v-btn>
                      <v-btn color="primary" @click="submitDialogEmail()">{{ $t('submit') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
          <v-card>
            <v-list three-line dense subheader>
              <v-subheader>{{ $tc('periods', 2, {count: ''}) | cap }}</v-subheader>
              <v-list-tile v-for="(period, i) in report.periods" :key="i">
                <v-list-tile-content>
                  <v-list-tile-title>{{ period.title }}</v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ period.period | periodToString }}
                    <br>
                    <small>{{ period.nextSend.date | date }}</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-menu bottom left v-if="!report.isFull">
                    <v-btn slot="activator" icon >
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile @click="openDialogPeriod(i, period)">
                        <v-list-tile-title>{{ $t('edit') | cap }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="confirmDeletePeriod(i)">
                        <v-list-tile-title>{{ $t('delete') | cap }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile v-if="!report.isFull">
                <v-btn
                  small
                  flat
                  color="primary"
                  @click="openDialogPeriod(-1)"
                >{{ $t('add') }} {{ $tc('periods', 1, {count: ''}) }}</v-btn>
                <v-dialog v-model="dialogPeriod" max-width="350" persistent>
                  <v-card>
                    <v-card-title class="primary white--text">
                      {{ dialogPeriodIndex !== -1 ? $t('edit') : $t('add') | cap }}
                      {{ $tc('period', 1, {count:''}) }}
                    </v-card-title>
                    <v-card-text>
                      <v-form
                        ref="formPeriod"
                        v-model="validFormPeriod"
                        lazy-validation
                      >
                        <v-text-field
                          v-model="periodTmp.title"
                          :label="$t('title') | cap"
                          box
                          required
                          :rules="[(v) => !!v || $t('required')]"
                        ></v-text-field>
                        <v-select
                          v-model="periodTmp.period"
                          :label="$t('period') | cap"
                          :items="periods"
                          box
                          :rules="periodRules"
                        ></v-select>
                        <v-subheader>
                          {{ $t('nextSend') }}
                        </v-subheader>
                        <v-date-picker
                          v-model="periodTmp.nextSend.date"
                          :locale="$i18n.locale"
                          full-width
                        ></v-date-picker>
                      </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat @click="cancelDialogPeriod()">{{ $t('cancel') }}</v-btn>
                      <v-btn color="primary" @click="submitDialogPeriod()">{{ $t('submit') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
          <v-card>
            <v-list dense subheader>
              <v-subheader>{{ $tc('sites', 2, {count: ''}) | cap }}</v-subheader>
              <v-list-tile v-for="(site, i) in report.sites" :key="i">
                <v-list-tile-content>
                  <v-list-tile-title>{{ site.url }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-menu bottom left v-if="!report.isFull">
                    <v-btn slot="activator" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile @click="openDialogSite(i)">
                        <v-list-tile-title>{{ $t('edit') | cap }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="confirmDeleteSite(i)">
                        <v-list-tile-title>{{ $t('delete') | cap }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile v-if="!report.isFull">
                <v-btn
                  small
                  flat
                  color="primary"
                  @click="openDialogSite(-1)"
                >{{ $t('add') }} {{ $tc('sites', 1, {count: ''}) }}</v-btn>
                <v-dialog v-model="dialogSite" max-width="350" persistent>
                  <v-card>
                    <v-card-title class="primary white--text">
                      {{ dialogSiteIndex === -1 ? $t('add') : $t('edit') | cap }}
                      {{ $tc('sites', 1, {count: ''}) }}
                    </v-card-title>
                    <v-card-text>
                      <wz-select-one-site></wz-select-one-site>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat @click="cancelDialogsite()">{{ $t('cancel') }}</v-btn>
                      <v-btn color="primary" @click="submitDialogsite()">{{ $t('submit') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer app height="auto" fixed inset v-if="hasChanged && !report.isFull">
      <v-layout justify-center row wrap>
        <v-btn flat round @click="cancelForm()">
          <v-icon left>refresh</v-icon>Annuler
        </v-btn>
        <v-btn color="primary" flat round @click="saveForm()">
          <v-icon left>check_circle</v-icon>Valider
        </v-btn>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { PERIODS_START, PERIODS_PRO, PERIODS_ENTREPRISE } from '../../../constants.js'
import _ from 'lodash'

const NEW_PERIOD = {
  id: 0,
  period: 1,
  title: '',
  prevSend: { date: '' },
  nextSend: { date: new Date().toISOString().split('T')[0] }
}

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },

  data: () => ({
    report: {},
    hasChanged: false,

    dialogTitle: false,
    titleTmp: '',

    dialogLang: false,
    langs: [
      {text: 'Français', value: 'fr'},
      {text: 'English', value: 'en'}
    ],
    langTmp: '',

    dialogEmail: false,
    dialogEmailIndex: -1,
    emailTmp: '',

    dialogPeriod: false,
    dialogPeriodIndex: -1,
    periodTmp: _.cloneDeep(NEW_PERIOD),
    validFormPeriod: true,

    dialogSite: false,
    dialogSiteIndex: -1
  }),

  created () {
    this.report = _.cloneDeep(this.reportFromStore)
    this.$store.commit('_Toolbar/SET_SUB_TITLE', this.report.title)
  },

  computed: {
    ...mapGetters('_Reports', {
      getReport: 'GET_REPORT',
      newReport: 'GET_NEW_REPORT'
    }),
    ...mapGetters('_User', { user: 'user' }),
    ...mapState('_Sites', { site: 'siteSelected' }),
    ...mapState('_User', ['entLevel']),

    reportFromStore () {
      if (this.id === 'new') {
        const report = Object.assign({}, this.newReport)
        report.entreprise.id = this.user.entId
        report.entreprise.name = this.user.entName
        return report
      }
      try {
        return this.getReport(Number.parseInt(this.id))
      } catch (e) {
        this.$router.push({ path: '/stats/reports' })
      }
    },

    emails () {
      return this.user.colleagues.map(u => u.USR_MAIL_CONTACT)
    },

    periods () {
      // période plus ou longue suivant la bride (ENTREPRISE)
      if (this.entLevel === '7') {
        // 1 an de données max
        return PERIODS_ENTREPRISE.map(period => ({
          text: this.$options.filters.periodToString(period),
          value: period,
          disabled: this.report.periods.findIndex(p => p.period === period) !== -1
        }))
      } else if (this.entLevel === '6') {
        // 30 jours de données max (PRO)
        return PERIODS_PRO.map(period => ({
          text: this.$options.filters.periodToString(period),
          value: period,
          disabled: this.report.periods.findIndex(p => p.period === period) !== -1
        }))
      } else if (this.entLevel === '5' || this.entLevel === '10' || this.entLevel === '1') {
        // 1 semaine de données max (CHAT, START, ESSAI)
        return PERIODS_START.map(period => ({
          text: this.$options.filters.periodToString(period),
          value: period,
          disabled: this.report.periods.findIndex(p => p.period === period) !== -1
        }))
      }
      // return PERIODS.map(period => ({
      //   text: this.$options.filters.periodToString(period),
      //   value: period,
      //   disabled: this.report.periods.findIndex(p => p.period === period) !== -1
      // }))
    },

    periodRules () {
      return [
        (v) => (this.dialogPeriodIndex !== -1 || this.report.periods.findIndex(p => p.period === v) === -1) || this.$t('alreadyExists')
      ]
    },

    siteTmp () {
      return {
        id: Number.parseInt(this.site.LIC_ID),
        url: this.site.LIC_URL
      }
    }
  },

  methods: {
    ...mapActions('_Reports', { saveReport: 'SAVE' }),
    ...mapActions('_Dialog', { setDialog: 'SET_DIALOG' }),
    ...mapActions('_Notifier', { newNotif: 'NEW_NOTIF' }),

    cancelForm () {
      this.hasChanged = false
      this.report = _.cloneDeep(this.reportFromStore)
    },
    async saveForm () {
      try {
        await this.saveReport(this.report)
      } catch (e) {
        this.newNotif({
          message: this.id === 'new'
            ? this.$t('creationFailure')
            : this.$t('modifFailure'),
          context: 'error'
        })
      }
      this.hasChanged = false
      if (this.id === 'new') {
        this.$router.push({ path: '/stats/reports' })
      } else {
        this.newNotif({
          message: this.$t('modifSuccess'),
          context: 'success'
        })
      }
    },

    openDialogTitle () {
      this.dialogTitle = true
      this.titleTmp = this.report.title
    },
    cancelDialogTitle () {
      this.dialogTitle = false
      this.titleTmp = ''
    },
    submitDialogTitle () {
      this.dialogTitle = false
      this.report.title = this.titleTmp
      this.hasChanged = true
    },

    openDialogLang () {
      this.dialogLang = true
      this.langTmp = this.report.lang
    },
    cancelDialogLang () {
      this.dialogLang = false
      this.langTmp = ''
    },
    submitDialogLang () {
      this.dialogLang = false
      this.report.lang = this.langTmp
      this.hasChanged = true
    },

    openDialogEmail (index, email) {
      this.dialogEmail = true
      this.dialogEmailIndex = index
      this.emailTmp = email
    },
    cancelDialogEmail () {
      this.dialogEmail = false
      this.dialogEmailIndex = -1
      this.emailTmp = ''
    },
    submitDialogEmail () {
      if (!this.emailTmp) {
        return
      }
      this.dialogEmail = false
      if (this.dialogEmailIndex === -1) {
        this.report.emails.push(this.emailTmp)
      } else {
        this.report.emails.splice(this.dialogEmailIndex, 1, this.emailTmp)
      }
      this.emailTmp = ''
      this.hasChanged = true
    },
    confirmDeleteEmail (idx) {
      this.setDialog({
        value: true,
        title: ``,
        text: `${this.$t('delete')} ${this.$t('email')} ?`,
        submit: 'delete',
        model: idx,
        submitCb: (idx) => {
          this.report.emails.splice(idx, 1)
          this.hasChanged = true
        }
      })
    },

    openDialogPeriod (index, period) {
      this.dialogPeriod = true
      this.dialogPeriodIndex = index
      this.periodTmp = _.cloneDeep(period) || _.cloneDeep(NEW_PERIOD)
    },
    cancelDialogPeriod () {
      this.dialogPeriod = false
      this.dialogPeriodIndex = -1
      this.periodTmp = _.cloneDeep(NEW_PERIOD)
    },
    submitDialogPeriod () {
      if (!this.$refs.formPeriod.validate()) {
        return
      }
      this.dialogPeriod = false
      if (this.dialogPeriodIndex === -1) {
        this.report.periods.push(this.periodTmp)
      } else {
        this.report.periods.splice(this.dialogPeriodIndex, 1, this.periodTmp)
      }
      this.periodTmp = _.cloneDeep(NEW_PERIOD)
      this.hasChanged = true
    },
    confirmDeletePeriod (idx) {
      this.setDialog({
        value: true,
        title: ``,
        text: `${this.$t('delete')} ${this.$t('period')} ?`,
        submit: 'delete',
        model: idx,
        submitCb: (idx) => {
          this.report.periods.splice(idx, 1)
          this.hasChanged = true
        }
      })
    },

    openDialogSite (index, site) {
      this.dialogSite = true
      this.dialogSiteIndex = index
    },
    cancelDialogsite () {
      this.dialogSite = false
      this.dialogSiteIndex = -1
    },
    submitDialogsite () {
      if (this.report.sites.find(s => s.id === this.siteTmp.id)) {
        return
      }
      this.dialogSite = false
      if (this.dialogSiteIndex === -1) {
        this.report.sites.push(this.siteTmp)
      } else {
        this.report.sites.splice(this.dialogSiteIndex, 1, this.siteTmp)
      }
      this.hasChanged = true
    },
    confirmDeleteSite (idx) {
      this.setDialog({
        value: true,
        title: ``,
        text: `${this.$t('delete')} ${this.$tc('sites', 1, {count: ''})} ?`,
        submit: 'delete',
        model: idx,
        submitCb: (idx) => {
          this.report.sites.splice(idx, 1)
          this.hasChanged = true
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/reports/ReportDetails.vue